import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

export const EventContext = createContext(null);

EventProvider.propTypes = {
    children: PropTypes.node,
};

export function EventProvider({ children }) {

    const [event, setEvent] = useState(null)
    const [account, setAccount] = useState(null)
    const [link, setLink] = useState(null)
    const [coupon, setCoupon] = useState(null)
    const [seasonTicket, setSeasonTicket] = useState(null)
    const [initialUserEventDetails, setInitialUserEventDetails] = useState(null)
    const [tickets, setTickets] = useState([])
    const [appliedCouponQs, setAppliedCouponQs] = useState(null)
    const [appliedHrcQS, setAppliedHrcQs] = useState(null)
    const [endUser, setEndUser] = useState(null)

    // Time slot state
    const [selectedDate, setSelectedDate] = useState(null)
    const [selectedTimeSlot, setSelectedTimeSlot] = useState(null)
    const [selectedTimeSlotDuration, setSelectedTimeSlotDuration] = useState(null)
    const [availableSlots, setAvailableSlots] = useState([])
    const [isLoadingSlots, setIsLoadingSlots] = useState(false)

    return (
        <EventContext.Provider
            value={{
                eventPageContext: {
                    event,
                    setEvent,
                    account,
                    setAccount,
                    link,
                    setLink,
                    tickets,
                    setTickets,
                    coupon,
                    setCoupon,
                    initialUserEventDetails,
                    setInitialUserEventDetails,
                    seasonTicket,
                    setSeasonTicket,
                    appliedCouponQs,
                    setAppliedCouponQs,
                    appliedHrcQS,
                    setAppliedHrcQs,
                    endUser,
                    setEndUser,
                    // Time slot context
                    selectedDate,
                    setSelectedDate,
                    selectedTimeSlot,
                    setSelectedTimeSlot,
                    selectedTimeSlotDuration,
                    setSelectedTimeSlotDuration,
                    availableSlots,
                    setAvailableSlots,
                    isLoadingSlots,
                    setIsLoadingSlots,
                },
            }}
        >
            {children}
        </EventContext.Provider>
    );
}

export const useEventContext = () => {
    const context = useContext(EventContext);

    if (!context) throw new Error('useEventContext context must be use inside EventProvider');

    return context;
};
